import { types } from "../Helpers/Types";

// Define el estado inicial
const initialState = {
    HDMenuCollapsed: false,
    // Drawer del aside en pantallas chicas (<= 1000px). Sustituye la manipulacion directa del
    // DOM (style.display) que dejaba el menu abierto sin forma de cerrarlo.
    HDMenuDrawerAbierto: false
};

export const GlobalStateReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MENU_COLLAPSED':
            return {
                ...state,
                HDMenuCollapsed: true, // marcar como colapsado
            };
        case 'MENU_EXPANDED':
            return {
                ...state,
                HDMenuCollapsed: false, // marcar como expandido
            };
        case 'MENU_DRAWER_TOGGLE':
            return {
                ...state,
                HDMenuDrawerAbierto: !state.HDMenuDrawerAbierto,
            };
        case 'MENU_DRAWER_CLOSE':
            return {
                ...state,
                HDMenuDrawerAbierto: false,
            };
        default:
            return state;
    }
};
